import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { UsersAndUniversityDepartments } from "../../admin/data-access/models/user-information.model";
import { Faculty } from "../../admin/data-access/models/faculties-model";

export const userProfilesActions = createActionGroup({
  source: 'User Profiles',
  events: {
    'Get User Profiles': emptyProps(),
    'Get User Profiles Success': props<{ userProfiles: UsersAndUniversityDepartments }>(),
    'Get User Profiles Failure': props<{ error: string }>()
  }
});

export const universityProfilesActions = createActionGroup({
  source: 'University Profiles',
  events: {
    'Get Faculties': emptyProps(),
    'Get Faculties Success': props<{ faculties: Faculty[] }>(),
    'Get Faculties Failure': props<{ error: string }>()
  }
})
